// extracted by mini-css-extract-plugin
export var askAiIcon = "_o4-9";
export var container = "_o4-0";
export var groupSeparator = "_o4-a";
export var highlight = "_o4-4";
export var resultIcon = "_o4-5";
export var resultItem = "_o4-7";
export var resultSubtitle = "_o4-3";
export var resultTitle = "_o4-2";
export var resultsList = "_o4-1";
export var searchGroup = "_o4-6";
export var selected = "_o4-8";